export default __webpack_public_path__ + "static/about-us-773bec39eb8eab5e219cc8b896c55148.png";